import { doc, getDoc, updateDoc } from "firebase/firestore";

export const generateInviteCode = (type) => {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 4; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  code += `-${type}-`;
  for (let i = 0; i < 4; i++) {
    code += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return code;
};

export const validateInviteCode = async (db, rawCode) => {
  const codeToCheck = rawCode.toUpperCase().trim();
  const codeDoc = await getDoc(doc(db, "inviteCodes", codeToCheck));

  if (!codeDoc.exists()) {
    throw new Error("유효하지 않은 초대 코드입니다.");
  }

  const codeData = codeDoc.data();

  if (codeData.maxUses && codeData.usedCount >= codeData.maxUses) {
    throw new Error("이 초대 코드는 더 이상 사용할 수 없습니다.");
  }

  if (codeData.expiresAt && new Date(codeData.expiresAt.toDate()) < new Date()) {
    throw new Error("만료된 초대 코드입니다.");
  }

  const orgDoc = await getDoc(doc(db, "organizations", codeData.organizationId));
  if (!orgDoc.exists()) {
    throw new Error("조직 정보를 찾을 수 없습니다.");
  }

  const orgData = orgDoc.data();
  return {
    organizationId: codeData.organizationId,
    orgName: orgData.name,
    deptName: codeData.departmentId || orgData.defaultDepartment,
    role: codeData.role,
    code: codeToCheck,
  };
};

export const incrementInviteCodeUsage = async (db, code) => {
  const inviteCodeRef = doc(db, "inviteCodes", code);
  const current = await getDoc(inviteCodeRef);
  const usedCount = current.data()?.usedCount || 0;

  await updateDoc(inviteCodeRef, {
    usedCount: usedCount + 1,
  });
};
